import { NAME_SPACES } from "shared/locales/constants";
import header from "./header";

const translations = { [NAME_SPACES.LAYOUT.HEADER]: header };

export default translations;
